import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { Button } from 'components/form/Button';
import { getImageBasePath } from 'helpers/env';
import { TextBox } from 'components/form/TextBox';
import './AutoLoanPurchaseModule.scss';
import { AUTO_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';

const AutoLoanPurchaseModuleView = ({
  datatestid,
  monthlyPayment,
  autoLoanSectionTooltip,
  autoLoanAmount,
  onChangeAutoLoanHandle,
  autoLoanFormError,
  onSeeAllOptions,
  onViewOfferDetailsClick,
  productKey,
  hasOffer,
  seenPixel,
  extraProps,
}) => {
  return (
    <FlexContainer
      datatestid={datatestid}
      className="justify-between m-justify-center autoloan-purchase-module"
    >
      {seenPixel}
      <div data-testid={`${datatestid}-inner`}>
        <FlexContainer className="align-baseline flex-column">
          <Label typeHeader={'h3'} className="H3 padTB8">
            Thinking about getting a new car?
          </Label>
          <FlexContainer className="justify-between format100">
            <div>
              <Label className="label text-20 m-text-16 margB10">
                Estimated payment:
              </Label>
              <div
                className="monthly-payment bold text-28 m-text-24"
                data-testid={`${datatestid}-monthlyPayment`}
              >
                {monthlyPayment}/mo.
              </div>
              <CSTooltip
                removeMarginsMobile
                isInline={true}
                placement={'bottom'}
                tooltipContent={autoLoanSectionTooltip}
                datatestid={`${datatestid}-cstooltip`}
                tooltipName="How is this calculated"
                vertical={AUTO_LOAN_VERTICAL}
                {...extraProps}
              >
                <Label type="link" className="Body-2 caption-large">
                  How is this calculated?
                </Label>
              </CSTooltip>
            </div>
            <div>
              <Label className="label text-20 m-text-16 margB10">
                Total car cost:
              </Label>
              <TextBox
                type="text"
                datatestid={`${datatestid}-loanAmount`}
                className="text-left"
                value={autoLoanAmount}
                onChange={onChangeAutoLoanHandle}
                error={autoLoanFormError}
              />
            </div>
          </FlexContainer>
          <div className="text-center desktopHide format100 padT40">
            <img
              alt="save money on your auto loan"
              src={getImageBasePath() + 'images/art-autopurchase.svg'}
            />
          </div>
          <div className="padT24 format100 m-text-center text-left">
            <Button
              className="desktopHide margB12"
              mrphType="link"
              onClick={() => onSeeAllOptions(extraProps)}
            >
              See All Options
            </Button>
            <Button
              mrphType="primary"
              className="format40 margR8 m-margr0"
              onClick={() => onViewOfferDetailsClick(productKey, extraProps)}
              disabled={!hasOffer}
              datatestid={`${datatestid}-viewoffer`}
            >
              View Offer
            </Button>
            <span className="mobileHide">
              <Button
                mrphType="link"
                onClick={() => onSeeAllOptions(extraProps)}
              >
                See All Options
              </Button>
            </span>
          </div>
        </FlexContainer>
      </div>
      <div className="mobileHide padT20">
        <img
          alt="save money on your auto loan"
          src={getImageBasePath() + 'images/art-autopurchase.svg'}
        />
      </div>
    </FlexContainer>
  );
};

export default AutoLoanPurchaseModuleView;
